import {fetch as fetchRaw} from '@lib/fetch'
import {riskAnalysis} from '../services'
import {getDefinedUrlSearchParams} from '@lib/util'

const fetch = (url, ...args) => fetchRaw([riskAnalysis.url, url], ...args)

export function companiesGet(queryParams) {
  return fetch(`/v3/companies?${getDefinedUrlSearchParams(queryParams)}`, {
    method: 'GET',
  })
}

export function riskAnalysisGetRisks(queryParams) {
  return fetch(`/v3/risks?${getDefinedUrlSearchParams(queryParams)}`, {
    method: 'GET',
  })
}

export function getRiskMapLandscapeData(queryParams) {
  return fetch(`/v3/risk-landscapes/maps?${getDefinedUrlSearchParams(queryParams)}`, {
    method: 'GET',
  })
}

export function getCountryRiskLandscapeData(queryParams) {
  return fetch(`/v3/risk-landscapes?${getDefinedUrlSearchParams(queryParams)}`, {
    method: 'GET',
  })
}

export function getRiskLandscapeCountryData(countryCode) {
  return fetch(`/v3/risk-landscape/${countryCode}`, {
    method: 'GET',
  })
}

export function getRiskLandscapeRiskDetailsCountriesData(queryParams) {
  return fetch(`/v3/risk-landscape/countries?${getDefinedUrlSearchParams(queryParams)}`, {
    method: 'GET',
  })
}

export function getRiskLandscapeRiskDetailsCompaniesData(queryParams) {
  return fetch(`/v3/risk-landscape/companies?${getDefinedUrlSearchParams(queryParams)}`, {
    method: 'GET',
  })
}

export function getRiskAssessments(queryParams) {
  return fetch(`/v3/assessment-blueprints?${getDefinedUrlSearchParams(queryParams)}`, {
    method: 'GET',
  })
}
export function getRiskAssessmentFormulas(queryParams) {
  return fetch(`/v3/rule-templates?${getDefinedUrlSearchParams(queryParams)}`, {
    method: 'GET',
  })
}

export function createRiskAssessment(body) {
  return fetch('/v3/assessment-blueprints', {
    method: 'POST',
    body: JSON.stringify(body),
  })
}

export function getRiskAssessmentBlueprint(id) {
  return fetch(`/v3/assessment-blueprints/${id}`, {
    method: 'GET',
  })
}

export function recalculateAssessment({blueprintId, companyIds}) {
  return fetch(`/v3/assessments/calculate`, {
    method: 'POST',
    body: JSON.stringify({blueprintId, companyIds}),
  })
}

export function recalculateStandardAssessment({blueprintId, companyIds}) {
  return fetch(`/v3/assessments/calculate/standard-assessment`, {
    method: 'POST',
    body: JSON.stringify({blueprintId, companyIds}),
  })
}

export function getBlueprintCompanies(id, queryParams) {
  return fetch(`/v3/blueprint-companies/${id}?${getDefinedUrlSearchParams(queryParams)}`, {
    method: 'GET',
  })
}

export function createBulkAssessment(body) {
  return fetch('/v3/blueprint-companies/bulk', {
    method: 'POST',
    body: JSON.stringify(body),
  })
}

export function getRiskGross(queryParams) {
  return fetch(`/v3/risk-gross?${getDefinedUrlSearchParams(queryParams)}`, {
    method: 'GET',
  })
}

export function updateRiskGross(id, body) {
  return fetch(`/v3/risk-gross/${id}`, {
    method: 'PATCH',
    body: JSON.stringify(body),
  })
}

export function createRiskGross(body) {
  return fetch('/v3/risk-gross', {
    method: 'POST',
    body: JSON.stringify(body),
  })
}

export function riskAnalysisAdminUpdateRisk(id, body) {
  return fetch(`/v3/risks/${id}`, {
    method: 'PATCH',
    body: JSON.stringify(body),
  })
}

export function riskAnalysisAdminCreateRisk(body) {
  return fetch('/v3/risks', {
    method: 'POST',
    body: JSON.stringify(body),
  })
}

export function updateRiskAssessment(id, body) {
  return fetch(`/v3/assessment-blueprints/${id}`, {
    method: 'PATCH',
    body: JSON.stringify(body),
  })
}

export function getAssessment(id) {
  return fetch(`/v3/assessments/${id}`, {
    method: 'GET',
  })
}

export function getAssessmentDetails(id, queryParams) {
  return fetch(`/v3/assessments/${id}/details?${getDefinedUrlSearchParams(queryParams)}`, {
    method: 'GET',
  })
}

export function createManualMitigation(body) {
  return fetch(`/v3/mitigations`, {
    method: 'POST',
    body: JSON.stringify(body),
  })
}

export function getAssessmentPrioritizationData(id) {
  return fetch(`/v3/assessments/${id}/prioritization-details`, {
    method: 'GET',
  })
}

export function getRemarks(assessmentId, queryParams) {
  return fetch(`/v3/mitigations/assessments/${assessmentId}?${getDefinedUrlSearchParams(queryParams)}`, {
    method: 'GET',
  })
}

export function getAssessmentHistory(id, queryParams) {
  return fetch(`/v3/assessments/${id}/history?${getDefinedUrlSearchParams(queryParams)}`, {
    method: 'GET',
  })
}

export function copyAssessmentFormula(ids) {
  return fetch(`/v3/rule-templates/copy`, {
    method: 'POST',
    body: JSON.stringify(ids),
  })
}

export function getBlueprintPrioritizationdata(id, queryParams) {
  return fetch(`/v3/blueprint-companies/${id}/prioritization-details?${getDefinedUrlSearchParams(queryParams)}`, {
    method: 'GET',
  })
}

export function getDatapointsDrawerData(assessmentId, riskId) {
  return fetch(`/v3/assessments/${assessmentId}/datapoints/${riskId}`, {
    method: 'GET',
  })
}

export function getAssessmentDatapointsDrawerData(assessmentId, queryParams) {
  return fetch(`/v3/assessments/${assessmentId}/rules/matched?${getDefinedUrlSearchParams(queryParams)}`, {
    method: 'GET',
  })
}

export function getAssessmentFormulaStatistics(id) {
  return fetch(`/v3/rule-templates/${id}/statistics`, {
    method: 'GET',
  })
}

export function assessmentBlueprintsByCompany(queryParams) {
  return fetch(
    `/v3/assessment-blueprints/${queryParams?.assessedCompanyId}/assessments?${getDefinedUrlSearchParams(queryParams)}`,
    {
      method: 'GET',
    }
  )
}

export function getRiskProfilePrioritizationDetails(companyId, blueprintId, queryParams) {
  return fetch(
    `/v3/risk-profiles/${companyId}/blueprints/${blueprintId}/prioritization-details?${getDefinedUrlSearchParams(queryParams)}`,
    {
      method: 'GET',
    }
  )
}

export function getRiskProfileRiskScores(companyId, blueprintId, queryParams) {
  return fetch(
    `/v3/risk-profiles/${companyId}/blueprints/${blueprintId}/risk-scores?${getDefinedUrlSearchParams(queryParams)}`,
    {
      method: 'GET',
    }
  )
}

export function getAssessmentHistoryByBlueprint(companyId, blueprintId) {
  return fetch(`/v3/assessment-blueprints/${blueprintId}/company/${companyId}/history`, {
    method: 'GET',
  })
}

export function getAssessmentRiskNotes(queryParams) {
  return fetch(`/v3/assessment-notes?${getDefinedUrlSearchParams(queryParams)}`, {
    method: 'GET',
  })
}

export function getAssessmentNotes(assessmentId, queryParams) {
  return fetch(`/v3/assessments/${assessmentId}/notes?${getDefinedUrlSearchParams(queryParams)}`, {
    method: 'GET',
  })
}

export function createAssessmentRiskNotes(body) {
  return fetch(`/v3/assessment-notes`, {
    method: 'POST',
    body: JSON.stringify(body),
  })
}

export function deleteAssessmentRiskNote(id) {
  return fetch(`/v3/assessment-notes/${id}`, {
    method: 'DELETE',
  })
}
export function getRelationshipTypes(queryParams) {
  return fetch(`/v3/relationship-types?${getDefinedUrlSearchParams(queryParams)}`, {
    method: 'GET',
  })
}

export function bulkArchiveAssessments(ids) {
  return fetch(`/v3/assessment-blueprints/archive`, {
    method: 'POST',
    body: JSON.stringify(ids),
  })
}
